<template>
  <div class="register-form" style="background:#e8f0fe ">
    <div class="login-box">
<!--      <img :src="bkImg" style="height: 100%; flex-shrink: 0;width: calc(100% - 420px);" />-->
      <div class="login-input">
        <!-- <img :src="logoImg" />-->
        <span class="title">延平区科特派服务云平台注册</span>
        <el-form :model="dataForm" :rules="dataRule" label-width="120px" ref="dataForm"
                 @keyup.enter.native="dataFormSubmit()" style="width: 100%; margin-top: 4vh;">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="姓名" prop="userName">
                <el-input v-model="dataForm.userName"  placeholder="姓名" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="证件类型" prop="documentType">
                <el-select class="input-item" v-model="dataForm.documentType" :clearable="true" filterable
                           placeholder="证件类型" :loading="specialForm.documentType.impl.loading"
                           @visible-change="specialForm.documentType.impl.onVisibleChange"
                >
                  <el-option v-for="item in specialForm.documentType.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证" prop="idCard">
                <el-input v-model="dataForm.idCard"  placeholder="身份证" autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生年月" prop="birthday">
                <el-date-picker class="input-item"
                  v-model="dataForm.birthday"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
<!--          </el-row>-->
<!--          <el-row :gutter="20">-->
            <el-col :span="8">
              <el-form-item label="性别" prop="gender">
                <el-select class="input-item" v-model="dataForm.gender" :clearable="true" filterable
                           placeholder="性别" :loading="specialForm.gender.impl.loading"
                           @visible-change="specialForm.gender.impl.onVisibleChange"
                           >
                  <el-option v-for="item in specialForm.gender.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="籍贯" prop="nativePlace">
                <el-input v-model="dataForm.nativePlace"  placeholder="籍贯"  autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份" prop="identity">
                <el-select class="input-item" v-model="dataForm.identity" :clearable="true" filterable
                           placeholder="身份" :loading="specialForm.identity.impl.loading"
                           @visible-change="specialForm.identity.impl.onVisibleChange"
                >
                  <el-option v-for="item in specialForm.identity.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="区级" prop="isDistrict">
                <el-select class="input-item" v-model="dataForm.isDistrict" :clearable="true" filterable
                           placeholder="区级" :loading="specialForm.isDistrict.impl.loading"
                           @visible-change="specialForm.isDistrict.impl.onVisibleChange"
                >
                  <el-option v-for="item in specialForm.isDistrict.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
<!--          </el-row>-->

<!--          <el-row :gutter="20">-->
            <el-col :span="8">
              <el-form-item label="民族" prop="nation">
                <el-input v-model="dataForm.nation"  placeholder="民族" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="政治面貌" prop="politicalOutlook">
                <el-input v-model="dataForm.politicalOutlook"  placeholder="政治面貌"  autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学历" prop="education">
                <el-select class="input-item" v-model="dataForm.education" :clearable="true" filterable
                           placeholder="学历" :loading="specialForm.education.impl.loading"
                           @visible-change="specialForm.education.impl.onVisibleChange"
                >
                  <el-option v-for="item in specialForm.education.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="最高学位" prop="degreeLevel">
                <el-select class="input-item" v-model="dataForm.degreeLevel" :clearable="true" filterable
                           placeholder="最高学位" :loading="specialForm.degreeLevel.impl.loading"
                           @visible-change="specialForm.degreeLevel.impl.onVisibleChange"
                >
                  <el-option v-for="item in specialForm.degreeLevel.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
<!--          </el-row>-->
<!--          <el-row :gutter="20">-->
            <el-col :span="8">
              <el-form-item label="专业领域" prop="specializedField">
                <el-input v-model="dataForm.specializedField"  placeholder="专业领域" autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="产业" prop="industryId">
                <el-cascader class="input-item"  v-model="dataForm.industryId" :options="specialForm.industryId.impl.dropdownList" filterable
                             :clearable="true" :show-all-levels="false" placeholder="产业"
                             :props="{value: 'id', label: 'name', checkStrictly: true}"
                             @visible-change="specialForm.industryId.impl.onVisibleChange"
                             @change="onIndustryIdValueChange"        />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职称" prop="specialistTitleId">
                <el-select class="input-item" v-model="dataForm.specialistTitleId" :clearable="true" filterable
                           placeholder="职称" :loading="specialForm.specialistTitleId.impl.loading"
                           @visible-change="specialForm.specialistTitleId.impl.onVisibleChange"
                >
                  <el-option v-for="item in specialForm.specialistTitleId.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工作单位（编制）" prop="companyName">
                <el-input v-model="dataForm.companyName"  placeholder="工作单位（编制）" autocomplete="off"
                ></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="8">
              <el-form-item label="统一社会信用代码" prop="creditCode">
                <el-input v-model="dataForm.creditCode"  placeholder="统一社会信用代码" autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="单位部门" prop="companyDept">-->
<!--                <el-input v-model="dataForm.companyDept"  placeholder="单位部门" autocomplete="off" ></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

<!--          </el-row>-->
<!--          <el-row :gutter="20">-->
            <el-col :span="8">
              <el-form-item label="工作单位属地" prop="companyArea">
                <el-input v-model="dataForm.companyArea"  placeholder="工作单位属地"  autocomplete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="单位性质" prop="companyProperties">
                <el-input v-model="dataForm.companyProperties"  placeholder="单位性质" autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="单位联系人" prop="companyContacts">
                <el-input v-model="dataForm.companyContacts"  placeholder="单位联系人" autocomplete="off"
                ></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人电话" prop="companyTel">
                <el-input v-model="dataForm.companyTel"  placeholder="联系人电话" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职位" prop="companyPost">
                <el-input v-model="dataForm.companyPost"  placeholder="职务" autocomplete="off"
                ></el-input>
              </el-form-item>

            </el-col>

            <el-col :span="8">
              <el-form-item label="服务单位" prop="serviceCompany">
                <el-input v-model="dataForm.serviceCompany"  placeholder="服务单位" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务对象" prop="serviceObjectName">
                <el-input v-model="dataForm.serviceObjectName"  placeholder="服务对象" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务地区" prop="serviceAreaId">
                <el-cascader class="input-item"  v-model="dataForm.serviceAreaId" ref="serviceAreaIdCas"
                             :options="specialForm.serviceAreaId.impl.dropdownList" filterable
                             :clearable="true" :show-all-levels="true" placeholder="服务地区"
                             :props="{value: 'id', label: 'name', checkStrictly: true}"
                             @visible-change="specialForm.serviceAreaId.impl.onVisibleChange"
                             @change="onServiceAreaIdValueChange"
                />              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务详细地址" prop="serviceAddress">
                <el-input v-model="dataForm.serviceAddress"  placeholder="服务详细地址" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>

<!--          </el-row>-->
<!--          <el-row :gutter="20">-->
            <el-col :span="8">
              <el-form-item label="学术称号" prop="academicTitle">
                <el-input v-model="dataForm.academicTitle"  placeholder="学术称号"  autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="主要服务产业" prop="confirmPassword">-->
<!--                <el-input v-model="dataForm.confirmPassword"  placeholder="主要服务产业" autocomplete="off"-->
<!--                ></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="8">-->
<!--              <el-form-item label="手机" prop="mobilePhone">-->
<!--                <el-input v-model="dataForm.mobilePhone"  placeholder="手机" autocomplete="off" ></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--          <el-row :gutter="20">-->
            <el-col :span="8">
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="dataForm.email"  placeholder="电子邮箱" autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="账号/手机号" prop="mobilePhone">
                <el-input v-model="dataForm.mobilePhone"  placeholder="账号/手机号" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>

          <el-col :span="8">
            <el-form-item label="密码" prop="password">
              <el-input v-model="dataForm.password" type="password" placeholder="密码"  autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="dataForm.confirmPassword" type="password" placeholder="确认密码" autocomplete="off"
                        ></el-input>
            </el-form-item>
          </el-col>
<!--            <div class="putbox">-->
          <el-col :span="8">
            <el-form-item label="验证码" prop="captcha">

                <el-input style="flex: 1;" placeholder="请输入验证码"
                         :custom-style="{background:'#f8f8f8',padding:'5rpx 20rpx',borderRadius:'50rpx',margin:'5rpx 0'}"
                         v-model="dataForm.captcha" type="text"></el-input>
<!--                <div :class="isDisabled?'codebtn2':'codebtn'" @click="getCode()" >-->
<!--                  <div>{{codeName}}</div>-->
<!--                </div>-->

            </el-form-item>
          </el-col>
            <el-col :span="4">
<!--              <el-form-item label="验证码" prop="captcha">-->
<!--                <div class="putbox">-->
<!--                  <el-input style="flex: 1;" placeholder="请输入验证码"-->
<!--                            :custom-style="{background:'#f8f8f8',padding:'5rpx 20rpx',borderRadius:'50rpx',margin:'5rpx 0'}"-->
<!--                            v-model="dataForm.captcha" type="text"></el-input>-->
                  <div :class="isDisabled?'codebtn2':'codebtn'" @click="getCode()" >
                    <div>{{codeName}}</div>
                  </div>
<!--                </div>-->
<!--              </el-form-item>-->
            </el-col>
<!--            </div>-->
          <el-button class="login-btn-submit" type="default" style="width: 20%; float: right; margin-left: 20px"
                     @click="goBack()"
          >
            返回
          </el-button>

          <el-button class="login-btn-submit" type="warning" style="width: 20%;float: right;"
                     @click="dataFormSubmit()"
                     :loading="isHttpLoading" :disabled="buttonDisabled">
            注册
          </el-button>
          </el-row>
        </el-form>
      </div>
    </div>
    <Verify
      ref="verify"
      @success="onVerifySuccess"
      :mode="'pop'"
      captchaType="blockPuzzle"
      :imgSize="{ width: '330px', height: '155px' }"
    />
  </div>
</template>

<script>
import { SystemController, DictionaryController } from '@/api';
import { mapMutations } from 'vuex';
import projectConfig from '@/core/config';
import { encrypt, setToken } from '@/utils';
import Verify from '@/components/Verifition/Verify.vue';
import { DropdownWidget } from '@/utils/widget.js';
import { validateSfz } from '@/utils/validateSfz.js';
export default {
  components: {
    Verify
  },
  data () {
    return {
      bkImg: require('@/assets/img/login.png'),
      /* logoImg: require('@/assets/img/login_logo.png'), */

      dataForm: {
      },
      specialForm: {
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        documentType: {
          impl: new DropdownWidget(this.loadDocumentTypeDropdownList)
        },
        identity: {
          impl: new DropdownWidget(this.loadIdentityDropdownList)
        },
        isDistrict: {
          impl: new DropdownWidget(this.loadIsDistrictDropdownList)
        },
        degreeLevel: {
          impl: new DropdownWidget(this.loadDegreeLevelDropdownList)
        },
        education: {
          impl: new DropdownWidget(this.loadEducationDropdownList)
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        serviceAreaId: {
          impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        isInit: false
      },

      dataRule: {
        mobilePhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            required: true, pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/g, message: '密码8-16位，应该包含大小写字母和数字', trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        specialistName: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        birthday: [
          {required: true, message: '请选择出生日期', trigger: 'change'}
        ],
        industryId: [
          {required: true, message: '请选择分类', trigger: 'change'}
        ],
        idCard: [
          // {required: true, message: '请输入身份证号码', trigger: 'blur'}
          { required: true, validator: validateSfz, trigger: 'blur' }
        ],
        companyName: [
          {required: true, message: '请输入工作单位（编制）', trigger: 'blur'}
        ],
        creditCode: [
          {required: true, message: '请输入统一社会信用代码', trigger: 'blur'}
        ],

        companyPost: [
          {required: true, message: '请输入职位', trigger: 'blur'}
        ],
        companyContacts: [
          {required: true, message: '请输入单位联系人', trigger: 'blur'}
        ],
        companyTel: [
          {required: true, message: '请输入单位联系电话', trigger: 'blur'}
        ],
        degreeLevel: [
          {required: true, message: '请选择学位', trigger: 'change'}
        ],
        specialistTitleId: [
          {required: true, message: '请选择职称', trigger: 'change'}
        ],
        isDistrict: [
          {required: true, message: '请选择是否区级', trigger: 'change'}
        ],
        education: [
          {required: true, message: '请输选择学历', trigger: 'change'}
        ],
        documentType: [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        nativePlace: [
          {required: true, message: '请输入籍贯', trigger: 'blur'}
        ],
        identity: [
          {required: true, message: '请选择身份', trigger: 'change'}
        ],
        nation: [
          {required: true, message: '请输入民族', trigger: 'blur'}
        ],
        politicalOutlook: [
          {required: true, message: '请输入政治面貌', trigger: 'blur'}
        ],
        serviceCompany: [
          {required: true, message: '请输入服务单位', trigger: 'blur'}
        ],
        companyArea: [
          {required: true, message: '请输入工作单位属地', trigger: 'blur'}
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        companyProperties: [
          {required: true, message: '请输入单位性质', trigger: 'blur'}
        ],
        serviceObjectName: [
          {required: true, message: '请输入服务对象', trigger: 'blur'}
        ],
        serviceAreaId: [
          {required: true, message: '请选择服务地区', trigger: 'blur'}
        ]
      },
      projectName: projectConfig.projectName,
      codeName: '获取验证码',
      isDisabled: false,
      time: 60,
      buttonDisabled: false
    };
  },
  methods: {
    dataFormSubmit () {
      let that = this
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          if (this.dataForm.captcha === '') {
            this.$message.warning('请输入验证码')
          }
          if (this.dataForm.password !== this.dataForm.confirmPassword) {
            this.$message.warning('确认密码不一致')
          }
          that.buttonDisabled = true
          this.dataForm.specialistName = this.dataForm.userName
          // this.dataForm.mobilePhone = this.dataForm.mobilePhone

          let params = {
            userPhone: this.dataForm.mobilePhone,
            password: encrypt(this.dataForm.password),
            captcha: this.dataForm.captcha,
            mobileUserType: 3,
            specialistDto: this.dataForm
          }
          SystemController.register(this, params, null, {showMask: false}).then(data => {
            // that.$message.success('注册成功！');
            // setTimeout(() => {
            //   // that.$router.replace({ name: 'login' });
            //   this.setMenuList(data.data.menuList);
            //   delete data.data.menuList;
            //
            //   this.setUserInfo(data.data);
            //   setToken(data.data.tokenData);
            //   this.setCurrentMenuId(null);
            //   this.$router.replace({ name: 'main' });
            // }, 1500)
            that.$message.success('注册成功前往登录吧！');
            setTimeout(() => {
              that.$router.replace({ name: 'login' });
            }, 1500)
          }).catch(e => {
            that.buttonDisabled = false
          });
        }
      });
    },
    getCaptcha (verifyParams) {
      let that = this
      let params = {
        userPhone: this.dataForm.mobilePhone,
        captchaVerification: (verifyParams || {}).captchaVerification
      };
      // setToken(null);
      SystemController.getCaptcha(this, params, null, {showMask: false}).then(data => {
        that.isDisabled = true;
        let interval = window.setInterval(function () {
          that.codeName = that.time + '秒后重新发送';
          --that.time;
          if (that.time < 0) {
            that.codeName = '重新发送';
            that.time = 180;
            that.isDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);
      }).catch(e => {});
    },
    onVerifySuccess (verifyParams) {
      this.getCaptcha(verifyParams);
    },
    getCode () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.$refs.verify.show();
        }
      });
    },
    /**
     * 是否委派下拉数据获取函数
     */
    loadAppointFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否委派选中值改变
     */
    onAppointFlagValueChange (value) {
    },
    /**
     * 性别下拉数据获取函数
     */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGenderDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadDocumentTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDocumentTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIdentityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIdentityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIsDistrictDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDistrictDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadDegreeLevelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDegreeLevelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 学历下拉数据获取函数
     */
    loadEducationDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictEducationDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 学历选中值改变
     */
    onEducationValueChange (value) {
    },
    /**
     * 职称下拉数据获取函数
     */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 分类下拉数据获取函数
     */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 分类选中值改变
     */
    onIndustryIdValueChange (value) {
      this.dataForm.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 所在地区下拉数据获取函数
     */
    loadServiceAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所在地区选中值改变
     */
    onServiceAreaIdValueChange (value) {
      this.dataForm.serviceAreaId = Array.isArray(value) ? value[value.length - 1] : undefined;

      const checkedNode = this.$refs['serviceAreaIdCas'].getCheckedNodes();
      let address = ''
      if (checkedNode.length > 0) {
        let arr = checkedNode[0].pathLabels;

        arr.forEach((item) => {
          address = address + item
        })
        this.dataForm.serviceAddress = address
      }
      // console.log(address)
    },
    goBack () {
      this.$router.replace({ name: 'login' });
    },
    ...mapMutations(['setUserInfo', 'setMenuList', 'setCurrentMenuId'])
  },
  mounted () {
    this.setMenuList([]);
    this.setUserInfo({});
    setToken();
  }
};
</script>

<style lang="scss">
  .register-form {
    width: 100vw;
    height: 100vh;
    background: #292D36;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-box {
      display: flex;
      align-items: center;
      height: 95vh;
      width: 95vw;
      padding: 5vh;
      border-radius: 3px;
      background: white;
      .login-input {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 356px;
          height: 42px;
          margin-top: 6vh;
        }
        .title {
          color: #232323;
          font-size: 20px;
          /*margin-top: 1vh;*/
        }
      }
    }
  }

  /*.register-form .el-input__inner {*/
  /*  height: 45px!important;*/
  /*}*/

  .register-form .el-button {
    height: 45px!important;
    font-size: 20px;
  }
  .putbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
  }

  .codebtn {
    width: 120px;
    height: 40px;
    font-size: 11px;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    background-color: #009dff;
    margin-left: 10px;
  }
  .codebtn2{
    width: 120px;
    height: 40px;
    font-size: 11px;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    background-color: #009dff;
    margin-left: 10px;
    pointer-events: none; // 禁止鼠标点击事件
  }
</style>
